import React from 'react';
import { Link } from 'react-scroll'
import { Link as GatsbyLink } from "gatsby"

type HomeAnchorProps = {
  isHome : boolean
  hash : string
  children ?: React.ReactNode
  activeClassName ?: string
  onClick ?: Function
  pagePath ?: string

}

const HomeAnchor = ({ isHome, hash, children, activeClassName, onClick, pagePath  } : HomeAnchorProps) => {
  return React.cloneElement( 
    children,
    !isHome ? { 
      as: GatsbyLink,
      to : `${pagePath ? pagePath : `/`}#${hash}`,
      activeClassName : activeClassName,
      onClick : onClick
    } : 
    { as : Link,
      to : hash,
      href : `${pagePath ? pagePath : `/`}#${hash}`,
      spy : true,
      smooth : true,
      activeClass : activeClassName,
      onClick : (e) => {
        if(window)
        {
          if (window.history.pushState) {
              // IE10, Firefox, Chrome, etc.
              window.history.pushState(null, '', `${pagePath ? pagePath : `/`}#${hash}`);
          } else {
              // IE9, IE8, etc
              window.location.hash = `#${hash}`;
          }
        }
        if(typeof onClick === "function")
          onClick();
      }
    }
  )
}

export default HomeAnchor;
